export const validateLastName = () => {
  const digitsExactLength = document.querySelectorAll('[digits-only-min-length]');
  const digitsMaxLengthValue = digitsExactLength[0]?.getAttribute('digits-only-max-length');
  const digitsMinLengthValue = digitsExactLength[0]?.getAttribute('digits-only-min-length');
  const digitsExactMessageValue = digitsExactLength[0]?.getAttribute('digits-only-error-message');

  if (digitsMaxLengthValue && digitsExactMessageValue && digitsMinLengthValue) {
    const lastNameInput = document.querySelector('[digits-only-min-length]');
    const lastNameInputValue = lastNameInput.value;
    const regex = new RegExp(`^[0-9]{${digitsMinLengthValue},${digitsMaxLengthValue}}$`);
    const isLastNameMandatory = document.querySelector('#RequiredMarkerPatientLastName');
    const isLastNameEmpty = lastNameInputValue.trim() === '';
    const isValid = isLastNameMandatory
      ? regex.test(lastNameInputValue)
      : regex.test(lastNameInputValue) || isLastNameEmpty;

    return {
      isValid,
      message: digitsExactMessageValue,
    };
  }

  return {
    message: '',
    isValid: true,
  };
};

export const validateRegex = () => {
  const lastNameInput = document.querySelector('[digits-only-min-length]');

  // When last name is mandatory/optional and has digits only validation disabled then result should be as before our changes were made
  if (!lastNameInput) {
    return true;
  }

  document.querySelector('.is-invalid-last-name')?.remove();
  document.querySelector('.add_to_cart-hcp')?.classList.remove('is-disabled');
  const { isValid, message } = validateLastName();

  if (!isValid) {
    let node = document.createElement('li');
    let textnode = document.createTextNode(message);
    node.appendChild(textnode);
    node.classList.add('is-invalid-last-name');
    document.querySelector('.configurator_summary__errors ul').appendChild(node);
    document.querySelector('.configurator_summary__errors').classList.remove('is-hidden');
    document.querySelector('.configurePatientInfo').classList.add('has-error');
    document.querySelector('[digits-only-min-length]').classList.add('is-invalid');
    document.querySelector('.add_to_cart-hcp')?.classList.add('is-disabled');

    return false;
  } else {
    return true;
  }
};

export const isPurchaseOrderNumberValid = (input) => {
  if (!input) {
    return {
      isValid: true,
      message: '',
    };
  }

  const isOptional = input.dataset.validationOptional === 'true';
  const value = input.value.trim();

  // Required but empty
  if (!isOptional && !value) {
    return {
      isValid: false,
      message: input.dataset.validationRequiredMessage,
    };
  }

  if (value) {
    // Invalid start character
    if (/^[=+\-/']/.test(value)) {
      return {
        isValid: false,
        message: input.dataset.validationInvalidMessage,
      };
    }

    // Digits only + fixed length
    const requiredLength = parseInt(input.dataset.validationDigitsOnlyLength, 10);
    if (requiredLength > 0) {
      if (!/^\d+$/.test(value) || value.length !== requiredLength) {
        return {
          isValid: false,
          message: input.dataset.validationDigitsOnlyErrorText,
        };
      }
    }

    // Field length (maxlength=20 is handled by the browser, but check explicitly))
    if (value.length > parseInt(input.getAttribute('maxlength') || '20', 10)) {
      return {
        isValid: false,
        message: input.dataset.validationFieldSizeMessage,
      };
    }
  }

  return {
    isValid: true,
    message: '',
  };
};
